<template>
  <router-view v-slot="slotProps" class="app">
    <transition name="route" mode="out-in">
      <component :is="slotProps.Component"></component>
    </transition>
  </router-view>
</template>

<script>
import Vue from "vue";
import i18n from "@/services/i18n/i18n";

export default {
  computed: {
    toasterData() {
      return this.$store.getters["enums/show_toaster_pop"];
    },
  },
  methods: {
    initApp() {
      let lang = localStorage.getItem("lang");

      if (
        !lang ||
        !this.$store.getters["enums/supportedLangs"].includes(lang)
      ) {
        lang = this.$store.getters["enums/defaultLang"];
        localStorage.setItem("lang", this.$store.getters["enums/defaultLang"]);
      }

      this.$store.dispatch("enums/SET_APP_LANG", lang);
      i18n.locale = lang;
      document.documentElement.setAttribute("lang", lang);
      document.documentElement.setAttribute(
        "dir",
        this.$store.getters["enums/rtlLangs"].includes(lang) ? "rtl" : "ltr"
      );
      Vue.prototype.locale = lang;
    },
    showToasterPop() {
      let toaster = this.toasterData;
      const h = this.$createElement;
      const variantColorMapping = {
        success: "#28a745",
        danger: "#dc3545",
        info: "#17a2b8",
        warning: "#ffc107",
        default: "#e63a96",
      };
      const variant = toaster?.variant || "default";
      const progressBarColor =
        variantColorMapping[variant] || variantColorMapping.default;
      const autoHideDelay =!toaster?.noAutoHide&& toaster?.duration || 5000;
      const noAutoHide = toaster?.noAutoHide || false;
      const animationDuration = `${autoHideDelay / 1000}s`;
      const vNodesMsg = h("p", { style: { marginBottom: 0 } }, [
        `${toaster?.message}`,
      ]);
      const vNodesTitle = h(
        "div",
        { class: ["d-flex", "flex-grow-1", "align-items-baseline", "mr-2"] },
        [h("strong", { class: "mr-2" }, `${toaster?.title || "title"}`)]
      );
      const vNodesProgressBar = !noAutoHide &&h("div", { class: "progress" }, [
        h("div", {
          class: "progress-bar-toast",
          style: {
            animationDuration: animationDuration,
            backgroundColor: progressBarColor,
          },
        }),
      ]);
      this.$bvToast.toast([vNodesMsg, vNodesProgressBar], {
        title: vNodesTitle,
        variant: toaster?.variant || "default",
        solid: true,
        toastClass: noAutoHide?"":"toast-with-progress",
        noHoverPause: true,
        toaster:
          this.isLangRtl
          ? "b-toaster-top-left"
          : "b-toaster-top-right",
        noCloseButton: toaster?.noCloseButton || false, 
        autoHideDelay: autoHideDelay,
        noAutoHide: noAutoHide,
        appendToast: true,
      });
      this.$store.dispatch("enums/SHOW_TOASTER_POP", {});
    },
  },
  watch: {
    toasterData(val) {
      if (Object.keys(val).length) {
        this.showToasterPop();
      }
    },
    $route(val) {
      if (val) {
        i18n.locale = this.$store.getters["enums/lang"];
      }
    },
  },
  created() {
    const favicon = document.getElementById("favicon");
    require("./SSS-theme.scss");
    favicon.href = "/SSS-favicon.ico";
    this.initApp();
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
@import "./custom.scss";
</style>

<style lang="scss">
.result {
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: var(--color-09);
}
.white-space-break {
  white-space: break-spaces;
}

.b-sidebar > .b-sidebar-header {
  display: none !important;
}

.filter-drivers,
.filter-list {
  hr {
    margin: 0.5rem 0 0.5rem 0;
  }
  &__head {
    margin-top: 15px;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: var(--color-17);
  }
  .filter-drivers__head {
    margin-bottom: 25px;
  }
  .filter-input-title {
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.4px;
    color: var(--color-61);
  }
  .time-placeHolder {
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: var(--color-02);
  }
  .input-time-group {
    width: 125px;
    height: 32px;
    padding: 0px 6px 0px 16px;
    border: 1px solid var(--color-04);
    border-radius: 4px;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.4px;
  }
  .datepicker-placeholder {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.4px;
    color: var(--color-02);
  }
  .label-text {
    margin-bottom: 5px;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.4px;
    color: var(--color-02);
  }
  .error-text {
    margin-bottom: 5px;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.4px;
    color: var(--color-47);
  }
  .search-btn {
    padding: 8px 20px;
  }
  .reset-btn {
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.4px;
    color: var(--color-23);
    padding-top: 0px;
  }
  .reset-btn:hover {
    color: var(--color-23);
  }
  .form-check-input {
    background-repeat: no-repeat;
    background-size: contain;
    padding: 8px;
    &:checked[type="radio"] {
      background-image: url("@/assets/images/icons/Radio.svg");
      background-color: transparent;
      border-color: var(--color-36);
      padding: 8px;
    }
    &:focus {
      box-shadow: unset;
    }
  }
}
</style>
